import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const DeviceSmartphoneFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M15.7464 19.1197H8.25349V4.87976H15.7464V19.1197ZM11.1533 17.3854C11.1533 16.9498 11.5266 16.5557 11.9829 16.5557C12.4599 16.5557 12.8333 16.9498 12.8333 17.3854C12.8333 17.8624 12.4599 18.2356 11.9829 18.2356C11.5266 18.2356 11.1533 17.8624 11.1533 17.3854ZM9.73469 5.98144H14.2652V7.66143H9.73469V5.98144Z"
      />
      <path
        fillRule="evenodd"
        d="M15.8064 3.21973H8.19349C7.30982 3.21973 6.59351 3.9361 6.59351 4.81977V19.1798C6.59351 20.0634 7.30982 20.7797 8.19349 20.7797H15.8064C16.6901 20.7797 17.4064 20.0634 17.4064 19.1798V4.81977C17.4064 3.9361 16.6901 3.21973 15.8064 3.21973ZM15.7464 19.1197H8.25349V4.87976H15.7464V19.1197Z"
      />
    </SvgIcon>
  );
});
